module.exports = __webpack_public_path__ + "assets/img/dayu_m_header.16452e97.png";